export const PHYSICIAN_PROFESSION_ID = '968e446f-cf8b-4a9f-ab55-632a1e66aef6'
export const ANESTHESIOLOGIST_ASSISTANT_ID =
  '34bd9bbd-53b6-40fa-b242-e194abec3c50'
export const NURSE_ANESTHETIST_ID = '599789cf-24f9-4c3d-8645-5d6072e117f1'
const NURSE_MIDWIFE_ID = '2b66ce1a-bd9a-4119-9baf-e6f54153ed80'
export const NURSE_PRACTITIONER_ID = '7b99e034-bd04-4364-943e-f576b26e5124'
export const PHYSICIAN_ASSISTANT_ID = '46f2ff02-0cfc-4879-a4e2-28becc089c44'
export const PHYSICIAN_SLUG = 'physician'
export const PHYSICIAN_ASSISTANT_SLUG = 'physician-assistant'
export const NURSE_PRACTITIONER_SLUG = 'nurse-practitioner'
export const NURSE_ANESTHETIST_SLUG = 'crna'
export const NURSE_MIDWIFE_SLUG = 'nurse-midwife'
export const ANESTHESIOLOGIST_ASSISTANT_SLUG = 'anesthesiologist-assistant'

export const professsionSlugIds = {
  [PHYSICIAN_PROFESSION_ID]: PHYSICIAN_SLUG,
  [ANESTHESIOLOGIST_ASSISTANT_ID]: ANESTHESIOLOGIST_ASSISTANT_SLUG,
  [NURSE_ANESTHETIST_ID]: NURSE_ANESTHETIST_SLUG,
  [NURSE_MIDWIFE_ID]: NURSE_MIDWIFE_SLUG,
  [NURSE_PRACTITIONER_ID]: NURSE_PRACTITIONER_SLUG,
  [PHYSICIAN_ASSISTANT_ID]: PHYSICIAN_ASSISTANT_SLUG,
}

export const professionSlugsToIds = Object.fromEntries(
  Object.entries(professsionSlugIds).map(([slug, id]) => [id, slug]),
)

export const professionSlugs = Object.values(professsionSlugIds)

export const professionOptions = [
  { label: 'Physician', slug: PHYSICIAN_SLUG, id: PHYSICIAN_PROFESSION_ID },
  {
    label: 'Physician Assistant',
    slug: PHYSICIAN_ASSISTANT_SLUG,
    id: PHYSICIAN_ASSISTANT_ID,
  },
  {
    label: 'Nurse Practitioner',
    slug: NURSE_PRACTITIONER_SLUG,
    id: NURSE_PRACTITIONER_ID,
  },
  {
    label: 'Anesthesiologist Assistant',
    slug: ANESTHESIOLOGIST_ASSISTANT_SLUG,
    id: ANESTHESIOLOGIST_ASSISTANT_ID,
  },
  {
    label: 'Nurse Anesthetist',
    slug: NURSE_ANESTHETIST_SLUG,
    id: NURSE_ANESTHETIST_ID,
  },
  { label: 'Nurse Midwife', slug: NURSE_MIDWIFE_SLUG, id: NURSE_MIDWIFE_ID },
]

const appOrPhysicianProfessionIds = professionOptions.reduce(
  (acc, curr) => {
    acc[curr.id] = true
    return acc
  },
  {} as Record<string, boolean>,
)

export function isAppOrPhysician(professionId: string): boolean {
  return Boolean(appOrPhysicianProfessionIds[professionId])
}

export const yearsOfTrainingOptions = [
  { id: '0,2', label: '0-2 years' },
  { id: '3,5', label: '3-5 years' },
  { id: '6,10', label: '6-10 years' },
  { id: '11,15', label: '11-15 years' },
  { id: '16,20', label: '16-20 years' },
  { id: '20+', label: '20+ years' },
]

export enum WorkStatus {
  Practicing = 'practicing',
  Fellow = 'fellow',
  Resident = 'resident',
  InTraining = 'inTraining',
}

export const physicianWorkOptions = [
  { id: WorkStatus.Practicing, label: 'Practicing' },
  { id: WorkStatus.Fellow, label: 'Fellow' },
  { id: WorkStatus.Resident, label: 'Resident' },
]

export const advanceClinicianWorkOptions = [
  { id: WorkStatus.Practicing, label: 'Practicing' },
  { id: WorkStatus.InTraining, label: 'In-Training' },
]

export const professionCodeMap: Record<string, string> = {
  [NURSE_PRACTITIONER_ID]: 'NP',
  [PHYSICIAN_ASSISTANT_ID]: 'PA',
  [NURSE_ANESTHETIST_ID]: 'CRNA',
  [ANESTHESIOLOGIST_ASSISTANT_ID]: 'AA',
  [NURSE_MIDWIFE_ID]: 'CNM',
}
